/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'ssl-certificate-signing-request';
const prefix = `${moduleName}.${componentName}`;

export const certificateSigningRequestLabel = `${prefix}.certificateSigningRequestLabel`;
export const signingRequestPlaceholder = `${prefix}.signingRequestPlaceholder`;
export const certificateInputLabel = `${prefix}.certificateInputLabel`;
export const certificateFileInputPlaceholder = `${prefix}.certificateFileInputPlaceholder`;

export const ENGLISH = {
    [certificateSigningRequestLabel]: 'Certificate Signing Request',
    [signingRequestPlaceholder]: 'Enter CSR',
    [certificateFileInputPlaceholder]: 'Paste Certificate',
    [certificateInputLabel]: 'Upload or Paste Certificate File',
};
